<template>
    <!-- MODALES -->
    <sweet-modal ref="bank_modal" :title="'Nuevo banco'" hide-close-button blocking>
        <!-- START FORM -->
        <div class="card-body">
            <div class="form-group">
                <label>Nombre</label>
                <input :class="{ 'is-invalid': $v.name.$error }" v-model.trim="name" class="form-control" type="text" />

                <div v-if="$v.name.$error">
                    <span v-if="!$v.name.required" class="help-block help-block-error">El nombre es requerido</span>
                </div>
            </div>
        </div>
        <!-- END FORM -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button slot="button" type="button" class="btn btn-primary ladda-button" data-style="expand-right"
            @click="saveBank()">Guardar</button>
    </sweet-modal>
    <!-- END MODALES -->
</template>
<script>
    import { SweetModal, SweetModalTab } from "sweet-modal-vue";
    import { required, sameAs, minLength, between } from "vuelidate/lib/validators";
    import ladda from "ladda";
    export default {
        install(Vue, options) {
            Vue.component("SweetModal", SweetModal);
            Vue.component("SweetModalTab", SweetModalTab);
        },
        validations: {
            name: {
                required
            }
        },
        components: {
            SweetModal,
            SweetModalTab,
        },
        data(){
            return{
                name:'',
                Bank:{
                    id:0,
                    name:''
                }
            }
        },
        methods:{
            openModal(accion, data = []) {
               this.$refs.bank_modal.open();
               this.$v.$reset()
               this.name='';
            },
            closeModal() {
                this.$refs.bank_modal.close();
            },
            saveBank() {
                var l = ladda.create(document.querySelector(".ladda-button"));
                this.$v.$touch();
                let me = this;
                if (this.$v.$invalid) {
                    toastr.error("Revise los campos", "Error");
                } else {
                    l.start();
                    axios
                        .post("/api/setting/newBank", {
                            name: this.name
                        })
                        .then(function (response) {
                            toastr.success(response.data.message, "Listo");
                            toastr.success(response.data.name);
                            me.Bank.id=response.data.id;
                            me.Bank.name=response.data.name;
                            me.selectBank();
                            toastr.success(response.data.message, 'Listo');
                            l.stop();
                            me.closeModal();
                        })
                        .catch(function (error) {
                            l.stop();
                            toastr.error(error.response.data.message, "Error");
                        });
                }
            },
            selectBank(){
                this.$emit('update-bank',this.Bank);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/utils/BankNew.vue